<div *ngIf="application && applicationResource">
  <mat-card>
    <mat-card-header class="table-header">
      <mat-card-title>Detalle de la Aplicación</mat-card-title>
      <mat-card-subtitle>
        <app-application-outline [applicationResource]="applicationResource"></app-application-outline>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <app-application-form [steps]="application.steps" [step]="currentStep"
                            (onStepCompleted)="stepCompleted($event)">
      </app-application-form>
    </mat-card-content>
  </mat-card>
</div>
